import { useRef } from "react";
import {
    motion,
    useScroll,
    useTransform,
    useReducedMotion,
} from "framer-motion";

const QUOTE_PARAS = [
    "At DUHA GLOBAL TRADING SDN. BHD., our vision is built on the belief that international trade is one of the most powerful tools for economic growth, collaboration and global development.",
    "We see Malaysia as a strategic gateway that connects East and West, enabling businesses to access some of the most important markets in the world.",
    "Our mission is to create a strong and efficient trading ecosystem that connects manufacturers, suppliers, distributors and consumers across continents.",
    "We are committed to building long-term partnerships based on trust, integrity and mutual growth.",
];

export const Chairman = () => {
    const ref = useRef(null);
    const reduce = useReducedMotion();
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const portraitY = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

    return (
        <section
            ref={ref}
            id="chairman"
            data-testid="chairman-section"
            className="relative bg-[#0B0807]/82 backdrop-blur-md py-24 sm:py-32 lg:py-40 px-4 sm:px-8 lg:px-12 border-t border-white/5 overflow-hidden"
        >
            <div className="flex items-center gap-3 font-mono-text text-[10px] sm:text-xs uppercase tracking-[0.3em] text-zinc-500 mb-6">
                <span className="h-px w-10 bg-[#D69331]" />
                <span>10 / Message From Chairman</span>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
                <div className="lg:col-span-5 order-2 lg:order-1">
                    <div className="relative aspect-[3/4] w-full max-w-md overflow-hidden border border-white/10 bg-[#0a0a0a]">
                        <motion.img
                            src="https://duhagt.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-02-at-01.25.40.jpeg"
                            alt="Seyed Alireza Naeinian, Executive Chairman and Founder"
                            style={reduce ? {} : { y: portraitY }}
                            className="absolute inset-0 w-full h-[115%] object-cover grayscale contrast-110"
                            loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                        <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-white/15">
                            <p className="font-display uppercase text-lg sm:text-xl text-white leading-tight">
                                Seyed Alireza Naeinian
                            </p>
                            <p className="font-mono-text text-[10px] uppercase tracking-[0.3em] text-[#D69331] mt-2">
                                Executive Chairman & Founder
                            </p>
                        </div>
                    </div>
                </div>

                <div className="lg:col-span-7 order-1 lg:order-2">
                    <motion.h2
                        initial={{ y: 40, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        viewport={{ once: true, margin: "-50px" }}
                        transition={{ duration: 0.8 }}
                        className="font-display uppercase font-bold leading-[0.9] tracking-tight text-white text-3xl sm:text-5xl lg:text-6xl"
                    >
                        Building a global trade future{" "}
                        <span className="text-[#D69331]">from Malaysia.</span>
                    </motion.h2>

                    <div className="mt-10 space-y-6 border-l-2 border-[#D69331] pl-6 sm:pl-8">
                        {QUOTE_PARAS.map((p, i) => (
                            <motion.p
                                key={i}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-30px" }}
                                transition={{ duration: 0.6, delay: i * 0.08 }}
                                className="font-mono-text text-sm sm:text-base text-zinc-300 leading-relaxed"
                            >
                                {p}
                            </motion.p>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
